export default "__VITE_ASSET__CNn2JNF7__"